import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from '@azure/msal-angular';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './auth/msal.utils';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { environment } from '../environments/environment';
import { LOCALE_ID } from '@angular/core';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { STORE_PORTFOLIOS, STORE_PROFILE_PICTURES, STORE_SECURITIES } from './shared/types/constants';
import { provideServiceWorker } from '@angular/service-worker';
import { OptInIdlePreloadStrategy } from './shared/utils/preload.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(OptInIdlePreloadStrategy), withComponentInputBinding()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    importProvidersFrom(
      LoggerModule.forRoot({
        level: environment.env === 'production' ? NgxLoggerLevel.OFF : NgxLoggerLevel.LOG,
        serverLogLevel: NgxLoggerLevel.OFF,
        enableSourceMaps: environment.env !== 'production'
      })
    ),
    importProvidersFrom(
      NgxIndexedDBModule.forRoot({
        name: 'OrderFlowDb',
        version: 4,
        objectStoresMeta: [
          {
            store: STORE_SECURITIES,
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
              { name: 'currency', keypath: 'currency', options: { unique: false } },
              { name: 'faSecurityCode', keypath: 'faSecurityCode', options: { unique: true } },
              { name: 'isin', keypath: 'isin', options: { unique: false } },
              { name: 'name', keypath: 'name', options: { unique: false } },
              { name: 'type', keypath: 'type', options: { unique: false } }
            ]
          },
          {
            store: STORE_PORTFOLIOS,
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
              { name: 'accounts', keypath: 'accounts', options: { unique: false } },
              { name: 'portfolio', keypath: 'portfolio', options: { unique: false } }
            ]
          },
          {
            store: STORE_PROFILE_PICTURES,
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
              { name: 'expiresAt', keypath: 'expiresAt', options: { unique: false } },
              { name: 'updatedAt', keypath: 'updatedAt', options: { unique: false } }
            ]
          }
        ]
      })
    )
  ]
};

